import React, { useEffect } from 'react'
import { Box } from '@mui/material'
import { useSignal } from '@preact/signals-react'
import { ModalSeeker } from '@ui-seeker/core'

import { AppButtonIcon } from '@components'
import { useToast } from '@hooks'


/**
 * Renders a chart inline with a fullscreen toggle, and again inside a fullscreen
 * modal while open.
 *
 * `renderChart` receives the props that differ between the two — id, height and
 * header slot — so the series and axis config live in one place instead of being
 * duplicated per view, which is how the two copies drift apart.
 */
export default function ChartFullScreen({ rootID, height = 500, renderChart }) {
	const isOpen = useSignal(false)
	const { showToast } = useToast()

	const toggle = () => {
		isOpen.value = !isOpen.value
	}

	useEffect(() => {
		if (isOpen.value) showToast.info("Press ESC to exit fullscreen mode")
	}, [isOpen.value])

	return <>
		{renderChart({
			rootID,
			sx: { height },
			cardProps: {
				actions: <AppButtonIcon
					sx={{ mr: 2 }}
					iconProps={{ iconWeight: "solid" }}
					tooltip="Fullscreen"
					icon="expand-wide"
					onClick={toggle}
				/>
			},
		})}

		{isOpen.value && <ModalSeeker
			isOpen
			controller={toggle}
			card={{ sx: { p: 0 } }}
			containerProps={{ fullScreen: true, sx: { '.MuiDialogContent-root': { p: 0 } } }}
			hideActions>
			{renderChart({
				// A second amcharts root cannot share the inline chart's id.
				rootID: `${rootID}Fullscreen`,
				sx: { height: '90vh' },
				extraHeader: <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
					<AppButtonIcon
						sx={{ mr: 4 }}
						iconProps={{ iconWeight: "solid" }}
						tooltip="Close Modal"
						icon="xmark"
						onClick={toggle}
					/>
				</Box>,
			})}
		</ModalSeeker>}
	</>
}
